import { queryClient } from "~/backend/queryClient"
import {
  findOperationChainItemsQueryKey,
  useCreateOperationChainItem,
} from "~/gen/api"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useCreateOperationChainItemMutation = () =>
  useCreateOperationChainItem({
    mutation: {
      onSuccess: async (_, variables) => {
        await queryClient.invalidateQueries({
          queryKey: findOperationChainItemsQueryKey(
            variables.data.operationChainId
          ),
        })
        showSuccessNotification({
          title: "Success",
          message: "Operation chain item created",
        })
      },
      onError: (error) => {
        showAxiosError({
          error,
          showNotification: true,
          defaultMessage: "Failed to add operation chain item",
          notificationTitle: "Failed to add operation chain item",
        })
      },
    },
  })
